import React from 'react';
import './Banner.css';
import bannerImage from '../assets/banner.jpg';

const Banner = () => {
  return (
    <section className="banner">
      <div 
        className="banner-background"
        style={{
          backgroundImage: `url(${bannerImage})`
        }}
      >
        {/* Background image set via inline style */}
      </div>
      
      <div className="banner-overlay">
        <div className="banner-content">
          {/* Slogan */}
          <p className="banner-slogan">Authentic Indian Flavors</p>
          
          {/* Main Title */}
          <h1 className="banner-title">
            EXPERIENCE THE AUTHENTIC TASTE OF INDIA
          </h1>
          
          
          
          {/* Call to Action Button */}
          <button className="cta-btn">
            EXPLORE MENU
          </button>
        </div>
      </div>
    </section>
  );
};

export default Banner;
